import { 
	GET_COUNTRY_PARAMETER,
	GET_SONG_ID_PARAMETER
} from '../constants/parameter-action-types';

export const getCountryParameter = (payload) => ({ type: GET_COUNTRY_PARAMETER, payload});
export const getSongIdParameter = (payload) => ({type: GET_SONG_ID_PARAMETER, payload});
